import React, { useState } from 'react';
import styled from 'styled-components';
import Pagination from '@material-ui/lab/Pagination';

const PaginationContainer = styled(Pagination)`
  .MuiPaginationItem-root {
    height: 36px;
    width: 36px;
    margin: 0px;
    font-family: 'RobotoR', 'NotoKrR';
    font-weight: normal;
    color: ${(props) => props.theme.colors.grey600};
    font-size: 16px;
    line-height: 1.5;
  }
  .MuiPaginationItem-page.Mui-selected {
    background-color: #7851e7;
    color: white;
  }
`;

interface DefaultPaginationProps {
  lastPageNumber: number;
  setPageNumber: React.Dispatch<React.SetStateAction<number>>;
}

const DefaultPagination = ({
  lastPageNumber,
  setPageNumber,
}: DefaultPaginationProps) => {
  const onChangePage = (event: React.ChangeEvent<unknown>, page: number) => {
    setPageNumber(page);
    window.scrollTo(0, 0);
  };
  return (
    <PaginationContainer
      count={lastPageNumber}
      shape="rounded"
      onChange={onChangePage}
      defaultPage={1}
    />
  );
};

export default DefaultPagination;
